import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Highcharts from "@material-ui/core/es/styles/withStyles";
import blue from "@material-ui/core/es/colors/blue";
import grey from "@material-ui/core/es/colors/grey";

HighchartsMore(ReactHighcharts.Highcharts);


var config =  {
    chart: {
        type: 'bar',

    },

    yAxis: {
        min:0,
        max: 24,
        title: {
            text: 'Hora'
        },
        labels: {
            enabled: true
        }
    },
    legend: {
        enabled: false
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
     series: []

}

export default function RoitreadCycleDistributionOnHourStackedChart(prop) {
    const { series, filter, coluna } = prop;

    let configs = [];

    console.log('series', series, coluna);

    if (series) {
        let hourSeriesArray = [];


        // Cria series de horarios produtivos e nao produticos
        let i=0;
        while (i<24) {

            hourSeriesArray.push({name: i+'h', data: [], color: '#54adff', index: 48- i*2 });
            hourSeriesArray.push({name: i+'h Não produtiva', data: [], color: '#dddddd', index: 47 - i*2 });
            i += 1;
        }

        //cria categorias e preenche horarios (series) com zero de producao
        let auxd = '';
        let auxh = 0;
        let categories = [];
        series.map(i => {
            let d = new Date(i.Data).toISOString().slice(0, 10);

            if (d !== auxd) {
                auxd = d;
                categories.push(auxd.slice(0, 10));

                auxh = 0;
                while (auxh <= 23) {
                    hourSeriesArray[auxh * 2].data.push(0);
                    hourSeriesArray[auxh * 2 + 1].data.push(1);
                    auxh += 1;
                }
            }

        })

        series.map( (i,ix) => {

            // buscar posicao do dia dentro das categorias
            let d = new Date(i.Data).toISOString().slice(0, 10);
            var index = categories.indexOf(d);

            //
            hourSeriesArray[i.Hora * 2].data[index] = i.PercTempo;
            hourSeriesArray[i.Hora * 2 + 1].data[index] = 1 - i.PercTempo;
        });


        config = {
            ...config,
            title: {
                text: 'Percentual da roitread em ciclo a cada hora do dia - coluna '+coluna
            },
            xAxis: {
                categories: categories,
                title: {
                    text: 'Dia'
                },
                labels: {
                    format: '{value}',
                    enabled: true
                }
            },

            series: hourSeriesArray

        }
        console.log('hourSeriesArray', hourSeriesArray);
    }


    return (
        <Card title="laos">
           <ReactHighcharts config = {config}>
                            </ReactHighcharts>

        </Card>
    )
}
